import { MinimalButton } from '@calendly/ui/components/minimal-button'

import { useUpgradeSubscription } from 'components/billing/use_upgrade_subscription'

export const UpgradeLink = ({ children }) => {
  const upgradeSubscription = useUpgradeSubscription({
    featureKey: 'workflows', skipPreface: true, paywall: 'workflows_workflows_banner', type: 'inline'
  })

  return <MinimalButton fontSize="medium" onClick={upgradeSubscription}>{children}</MinimalButton>
}
